import { useCurrencyStore } from '../../stores/currencyStore';

export function formatCurrency(amount: number): string {
  const { getSymbol } = useCurrencyStore.getState();
  const symbol = getSymbol();
  
  // Format number with thousands separator
  const formatted = amount.toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  
  return `${formatted} ${symbol}`;
}

export function useCurrency() {
  const { getSymbol } = useCurrencyStore();
  
  return {
    symbol: getSymbol(),
    format: formatCurrency,
  };
}
